<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p>Although this novel is based on facts, some events, characters, and places are fictional. Quotes from <em>The Bluefield Daily Telegraph</em>, and the railroad photographs were taken by Alyssa B. Weisner and are acknowledged with grateful appreciation.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?3e713ba4